export default __webpack_public_path__ + "fonts/no-skip-traced-numbers.svg";